import { MapPinIcon } from '@heroicons/react/24/outline'
import { Controller } from 'libs/form'
import type { FieldValues, UseFormReturn } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { FormSection, Select, Switch } from 'shared/components'
import { useFetchInfinite, useSelect } from 'shared/hooks'
import { InputGroup } from 'shared/molecules'

type AreaFormSectionsProps = {
	form: UseFormReturn<FieldValues>
}

export const AreaFormSections = ({ form }: AreaFormSectionsProps) => {
	const { t } = useTranslation()
	const {
		register,
		control,
		setValue,
		trigger,
		formState: { errors }
	} = form
	const fieldErrors = errors as any
	const { handleSelectChange } = useSelect({ setValue, trigger })

	const { data: boothTypes, fetchNextPage } = useFetchInfinite({
		name: 'fetchAreaTypes',
		endpoint: '/booth-types/'
	})
	const boothTypeOptions = (boothTypes?.pages ?? [])
		.flatMap((page: any) => page.results)
		.map((boothType: any) => ({ label: boothType.name, value: boothType.pk }))

	return (
		<FormSection
			title={t('Area')}
			description={t('The area type and the number shown on the store map.')}
			icon={<MapPinIcon />}>
			<Controller
				name="boothType"
				control={control}
				render={({ field }) => (
					<Select
						id="boothType"
						variant="form"
						label={t('Area type')}
						placeholder={t('Choose area type')}
						required
						options={boothTypeOptions}
						{...field}
						error={fieldErrors.boothType?.value}
						handleInfiniteScroll={fetchNextPage}
						onChange={(data: any) =>
							handleSelectChange({ id: 'boothType', value: data?.value, label: data?.label })
						}
					/>
				)}
			/>
			<InputGroup
				id="number"
				label={t('Area number')}
				placeholder="0"
				required
				{...register('number')}
				error={fieldErrors.number}
			/>
			<Switch
				className="sm:col-span-2"
				label={t('Active')}
				description={t('The area is shown in the booking process.')}
				{...register('is_active')}
			/>
		</FormSection>
	)
}
